import { setupWorker } from 'msw/browser'

import { createApiMockHandlers } from './createApiMockHandlers'

import type { ClientConfig } from '@ngb-frontend/shared/types'
import type { RequestHandler, SharedOptions } from 'msw'

// Don't inform about unhandled requests to these urls
const bypassUrls = `leaseplan|googleapis|maps|fonts|openstreetmap`

export const mswOptions = {
  onUnhandledRequest: (req: Request) => {
    const url = req.url
    const method = req.method

    if (!req.url) return

    if (!new RegExp(`${bypassUrls}|${window.location.host}`).test(`${url}`)) {
      throw new Error(`Unhandled ${method} request to ${url}`)
    }
  },
}

const setupWorkerApiMocks = (
  handlers: RequestHandler[],
  options?: SharedOptions | undefined,
) => {
  const worker = setupWorker(...handlers)
  worker.start(options)
  return worker
}

export const initApiMocks = (config: ClientConfig) => {
  const handlers = createApiMockHandlers(config)
  return setupWorkerApiMocks(handlers, mswOptions)
}
